import React, { useState, useRef, useEffect } from 'react';
import { Icon } from '../ui';

// Компактний мультивибір: кнопка з лічильником + список чекбоксів, що випадає.
// Замінює важку зв'язку FilterPanel + CheckboxGroup + SelectedFiltersDisplay,
// яка була прив'язана до одного джерела (infoshina).
const MultiSelectFilter = ({ label, options = [], selected = [], onChange, searchable = false, renderOption = o => o }) => {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, [open]);

    const toggle = (value) => {
        onChange(selected.includes(value)
            ? selected.filter(v => v !== value)
            : [...selected, value]);
    };

    const visible = query
        ? options.filter(o => String(o).toLowerCase().includes(query.toLowerCase()))
        : options;

    return (
        <div ref={ref} style={{ position: 'relative' }}>
            <button type="button" onClick={() => setOpen(o => !o)} aria-expanded={open}
                    className={`ui-pill${selected.length ? ' is-on' : ''}`}>
                {label}
                {selected.length > 0 && <span className="ui-pill-count">{selected.length}</span>}
                <Icon name="chevronDown" size={16} stroke={2} />
            </button>

            {open && (
                <div style={dropdownStyle}>
                    {searchable && (
                        <input
                            autoFocus
                            placeholder="Пошук…"
                            value={query}
                            onChange={e => setQuery(e.target.value)}
                            style={searchStyle}
                        />
                    )}
                    <div style={{ maxHeight: 240, overflowY: 'auto' }}>
                        {visible.length === 0 && (
                            <div style={{ padding: 12, color: 'var(--text-3)', fontSize: 13 }}>Нічого не знайдено</div>
                        )}
                        {visible.map(o => (
                            <label key={o} className="ui-option" style={optionStyle}>
                                <input
                                    type="checkbox"
                                    checked={selected.includes(o)}
                                    onChange={() => toggle(o)}
                                />
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{renderOption(o)}</span>
                            </label>
                        ))}
                    </div>
                    {selected.length > 0 && (
                        <button type="button" onClick={() => onChange([])} style={clearStyle}>
                            Очистити ({selected.length})
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

const dropdownStyle = {
    position: 'absolute', top: '100%', left: 0, marginTop: 6, zIndex: 50,
    background: 'var(--surface-2)', borderRadius: 18, padding: 6,
    boxShadow: 'var(--shadow)', minWidth: 220, maxWidth: 320,
};
const searchStyle = {
    width: '100%', marginBottom: 4, background: 'var(--surface)',
};
const optionStyle = {
    display: 'flex', alignItems: 'center', gap: 10, padding: '9px 10px',
    borderRadius: 10, fontSize: 14, cursor: 'pointer',
};
const clearStyle = {
    width: '100%', marginTop: 4, padding: '10px', border: 'none', borderRadius: 12,
    background: 'var(--surface)', color: 'var(--ink)', cursor: 'pointer', fontSize: 13, fontWeight: 600,
};

export default MultiSelectFilter;
